import React from 'react';
import SiteLayout from '../site/SiteLayout';
import ScheduleCall from '../site/ScheduleCall/ScheduleCall';
import useDocumentTitle from '../site/hooks/useDocumentTitle';
import AboutHero from './AboutHero/AboutHero';
import Founder from './Founder/Founder';
import OurStory from './OurStory/OurStory';
import WhatWeDo from './WhatWeDo/WhatWeDo';
import Principles from './Principles/Principles';

const AboutPage = () => {
  useDocumentTitle('About — DS360 Investment');

  return (
    <SiteLayout>
      <AboutHero />
      <Founder />
      <OurStory />
      <WhatWeDo />
      <Principles />
      <ScheduleCall eyebrow="Get in touch" />
    </SiteLayout>
  );
};

export default AboutPage;
